import { render, staticRenderFns } from "./Autocompletes.vue?vue&type=template&id=3aaa3f4a&"
import script from "./Autocompletes.vue?vue&type=script&lang=js&"
export * from "./Autocompletes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports